import useTranslation from "next-translate/useTranslation";
import React from "react";
import styled from "styled-components";
import { device } from "styles/Breakpoint";
import { Container, SectionTitle, TopTitle } from "styles/Common";
import Education from "./Education";
import Experience from "./Experience";

function index() {
  const { t } = useTranslation("common");

  return (
    <ResumePg>
      <Container>
        <TopTitle>{t("resume.title")}</TopTitle>
        <SectionTitle>{t("header.resume")}</SectionTitle>
        <Flex>
          <Ed>
            <Education />
          </Ed>
          <Exp>
            <Experience />
          </Exp>
        </Flex>
      </Container>
    </ResumePg>
  );
}

export default index;

const ResumePg = styled.section`
  background-color: var(--white);
  padding: 60px 0;
`;

const Flex = styled.div`
  display: flex;
  padding: 60px 0;
  @media ${device.tablet} {
    flex-wrap: wrap;
  }
`;

const Ed = styled.div`
  width: 50%;
  @media ${device.tablet} {
    width: 100%;
  }
`;

const Exp = styled.div`
  width: 50%;
  @media ${device.tablet} {
    width: 100%;
    margin-top: 60px;
  }
`;
